import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Route-level scroll handling for every link on the site (header, mega-menus, footer, CTAs):
 * - a new pathname without a hash starts at the top of the page;
 * - a hash (#section) scrolls to that section, retrying briefly while the page renders.
 * Works with browser back/forward since it reacts to the location itself.
 */
export function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer: ReturnType<typeof setTimeout>;
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else if (tries++ < 30) {
        timer = setTimeout(scrollToTarget, 60);
      }
    };
    scrollToTarget();
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return null;
}